import Box from '@mui/material/Box';
import { TitleDivider } from '@stack/ui/components';

import SpecAndFeatureDesktopView from './DesktopView/DesktopView';
import SpecAndFeatureMobileView from './MobileView/MobileView';
import ChargingTimeGraph from './ChargingTimeGraph';
export type SpecAndFeatureDataType = {
  id: number;
  model: string;
  carTitle: string;
  price: string;
  monthly: string;
  car_seat_number?: number;
  car_body_type_name?: string;
  car_variant_cc?: number;
  car_segment_type_name?: string;
  car_fuel_type_name?: string;
  car_fuel_type_slug?: string;
  car_variant_transmission?: string;
  engine_model?: string;
  kw_hp?: string;
  nm_torque?: string;
  top_speed?: string;
  '0_100_km_h'?: string;
  battery_type?: string;
  battery_capacity?: string;
  charger_type?: string;
  ac_charging_time?: string;
  dc_charging_time?: string;
  ac_max_input?: string;
  dc_max_input?: string;
  driving_range?: string;
};
export type SpecAndFeatureProps = {
  data: SpecAndFeatureDataType[];
  selected?: SpecAndFeatureDataType;
  onSelect: (data: SpecAndFeatureDataType) => void;
  webView?: boolean;
  showTitle?: boolean;
  showGraph?: boolean;
  showSpec?: boolean;
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const SpecAndFeature: React.FC<SpecAndFeatureProps> = (props) => {
  const {
    showGraph = true,
    showSpec = true,
    showTitle = true,
    ...restProps
  } = props;
  // ======================= VIEWS

  const renderView = () => {
    if (!showSpec) return null;
    return (
      <>
        <Box sx={{ display: { xs: 'block', md: 'none' } }}>
          <SpecAndFeatureMobileView {...props} />
        </Box>
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <SpecAndFeatureDesktopView {...props} />
        </Box>
      </>
    );
  };

  return (
    <>
      <TitleDivider title={showTitle ? 'Model Variant' : ''}>
        {renderView()}
        {showGraph && <ChargingTimeGraph {...restProps} />}
      </TitleDivider>
    </>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default SpecAndFeature;
